import FrequentlyAskedQuestions from 'components/frequentlyAskedQuestions';
import Page from 'components/page';
import { useTranslation } from 'utils/i18n';
import { serverSideTranslations } from '../../lib/serverSideTranslations';

const Faqs = () => {
  const { t } = useTranslation('common');

  return (
    <Page
      title={t('headers.faq_page.title')}
      description={t('headers.faq_page.description')}
    >
      <div className="faq">
        <h1>{t('faq.title')}</h1>

        <div className="faq__intro" id="faqIntro">
          <p>{t('faq.text')}</p>

          <ul>
            <li>
              {t('faq.see_here_for_additional')}{' '}
              <a
                href="https://www.property.nhs.uk/getting-started-with-nhs-open-space?utm_source=website&utm_campaign=faqpage"
                target="_blank"
                rel="noreferrer"
              >
                {t('faq.getting_started_with_nhs_openspace')}
              </a>
            </li>

            <li>
              {t('faq.view_and_download')}{' '}
              <a
                href="https://www.property.nhs.uk/news/news/nhs-open-space-training-resources/"
                target="_blank"
                rel="noreferrer"
              >
                {t('faq.guides_text')}
              </a>
            </li>
          </ul>

          <h4>{t('faq.help_topics')}</h4>
          <ol>
            <li>
              <a href="#howToUse">{t('faq.topics.how_to_use.title')}</a>
            </li>
            <li>
              <a href="#basics">{t('faq.topics.basics.title')}</a>
            </li>
            <li>
              <a href="#gettingStarted">
                {t('faq.topics.getting_started.title')}
              </a>
            </li>
            <li>
              <a href="#setupPayments">
                {t('faq.topics.setup_payments.title')}
              </a>
            </li>
            <li>
              <a href="#bookingsCancellations">
                {t('faq.topics.bookings_cancellations.title')}
              </a>
            </li>
            <li>
              <a href="#usingRoomsOnSite">
                {t('faq.topics.using_room_on_site.title')}
              </a>
            </li>
          </ol>
        </div>
        <FrequentlyAskedQuestions />
      </div>
    </Page>
  );
};

export const getServerSideProps = async ({ locale }: { locale: string }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};

export default Faqs;
